// VerificationPinnedNotification.jsx
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import PinnedNotification, {
  PinnedNotificationText,
  PinnedNotificationCTA,
} from '../component/PinnedNotification.jsx';
import { TranslationNamespace } from '../resource/translationNamespace.js';
import { NULL_FUNCTION } from '../resource/defaults.js';
import { ButtonId, ModalId } from '../resource/mixpanel.js';
import ResetButtonStyle from '../style/ResetButtonStyle.js';
import { breakpoint } from '../style/variables.js';

const VerificationPinnedNotification = ({
  shouldShow = false,
  openPhoneBindingModal = NULL_FUNCTION,
  openShopModal = NULL_FUNCTION,
}) => {
  const { t } = useTranslation();

  if (!shouldShow) return null;

  return (
    <PinnedNotification>
      <PinnedNotificationText>
        <Description>
          {t('kyc_verification_not_yet_complete', {
            ns: TranslationNamespace.AUTH,
          })}
        </Description>
      </PinnedNotificationText>
      <PinnedNotificationCTA>
        <VerifyButton
          data-element_id={ButtonId.Verification.ButtonPhoneVerify}
          data-tracking_payload={{
            modalId: ModalId.Notification.AgeVerification,
          }}
          onClick={openPhoneBindingModal}
        >
          {t('kyc_phone_verify', {
            ns: TranslationNamespace.AUTH,
          })}
        </VerifyButton>
        <BuyButton
          data-element_id={ButtonId.Verification.ButtonDiamondShop}
          data-tracking_payload={{
            modalId: ModalId.Notification.AgeVerification,
          }}
          onClick={openShopModal}
        >
          {t('buy_points', {
            ns: TranslationNamespace.AUTH,
          })}
        </BuyButton>
      </PinnedNotificationCTA>
    </PinnedNotification>
  );
};

VerificationPinnedNotification.propTypes = {
  shouldShow: PropTypes.bool,
  openPhoneBindingModal: PropTypes.func,
  openShopModal: PropTypes.func,
};

const Description = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const BaseButton = styled.button`
  ${ResetButtonStyle};
  min-width: 128px;
  flex: 1 1 128px;
  display: flex;
  height: 28px;
  padding: 4px 8px;
  justify-content: center;
  align-items: center;
  gap: 4px;

  border-radius: 4px;

  overflow: hidden;
  text-align: center;
  text-overflow: ellipsis;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
  letter-spacing: 0.014px;

  @media (max-width: ${breakpoint.tablet}px) {
    height: 24px;
    padding: 2px 8px;

    font-size: 12px;
    letter-spacing: 0.012px;
  }
`;

const VerifyButton = styled(BaseButton)`
  background: var(
    --interactive-interactive-button-color-tertiary-default-dark,
    #fff
  );

  color: var(--font-font-color-primary-light, #191919);
`;

const BuyButton = styled(BaseButton)`
  border: 1px solid
    var(--interactive-interactive-button-color-tertiary-default-dark, #fff);
  background: var(
    --background-background-buttonOutline-color-default-dark,
    rgba(35, 35, 35, 0.4)
  );

  color: var(
    --interactive-interactive-button-color-tertiary-default-dark,
    #fff
  );
`;

export default VerificationPinnedNotification;
